export const REQUEST_USER_INFO = 'user/REQUEST_USER_INFO';
export const REQUEST_ACTIVE_ROUND_PREDICTIONS =
    'user/REQUEST_ACTIVE_ROUND_PREDICTIONS';
export const RECEIVE_ACTIVE_ROUND_PREDICTIONS =
    'user/RECEIVE_ACTIVE_ROUND_PREDICTIONS';
export const RECEIVE_USER_INFO = 'user/RECEIVE_USER_INFO';
export const GO_TO_ACCOUNT = 'user/GO_TO_ACCOUNT';
export const WINDOW_RESIZE = 'user/WINDOW_RESIZE';
